import { TYPES_PACKAGE } from './package.types';

const INITIAL_STATE = {
  list: {
    data: null,
    loading: false,
    error: null,
  },
  hero: {
    data: null,
    loading: false,
    error: null,
  },
  feature: {
    data: null,
    loading: false,
    error: null,
  },
  offer: {
    data: null,
    loading: false,
    error: null,
  },
};

const packageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES_PACKAGE.GET_PACKAGE_DATA_LOADING:
      return { ...state, list: { ...state.list, loading: action.loading } };
    case TYPES_PACKAGE.GET_PACKAGE_LIST_DATA:
      return { ...state, list: { ...state.list, data: action.payload, error: action.error, loading: false } };
    case TYPES_PACKAGE.GET_SUBSCRIPTION_HERO_LOADING:
      return { ...state, hero: { ...state.hero, loading: action.loading } };
    case TYPES_PACKAGE.GET_SUBSCRIPTION_HERO_DATA:
      return { ...state, hero: { ...state.hero, data: action.payload, error: action.error, loading: false } };
    case TYPES_PACKAGE.GET_SUBSCRIPTION_FEATURE_LOADING:
      return { ...state, feature: { ...state.feature, loading: action.loading } };
    case TYPES_PACKAGE.GET_SUBSCRIPTION_FEATURE_DATA:
      return {
        ...state,
        feature: { ...state.feature, data: action.payload, error: action.error, loading: false },
      };
    case TYPES_PACKAGE.GET_SUBSCRIPTION_OFFER_LOADING:
      return { ...state, offer: { ...state.offer, loading: action.loading } };
    case TYPES_PACKAGE.GET_SUBSCRIPTION_OFFER_DATA:
      return { ...state, offer: { ...state.offer, data: action.payload, error: action.error, loading: false } };
    default:
      return state;
  }
};

export default packageReducer;
